/**
 * Öffnet die große Karte in einem neuen Tab.
 *
 * <p>Bewusst als Adresse und nicht als Dialog: So lässt sich der Tab neben der Liste
 * stehenlassen, während man weiterarbeitet — und der Link ist teilbar.
 *
 * <p>Steht in einer eigenen Datei, damit ein Aufrufer nur diese Funktion braucht und nicht
 * die halbe Kartenbibliothek mitlädt. Wer nie auf eine Karte klickt, soll ihre
 * zweihundert Kilobyte auch nicht herunterladen.
 */
export function oeffneKarte(werte: {
  breite?: number
  laenge?: number
  titel?: string
  flotte?: boolean
}) {
  const p = new URLSearchParams()
  if (werte.flotte) p.set('flotte', '1')
  if (werte.breite != null) p.set('breite', String(werte.breite))
  if (werte.laenge != null) p.set('laenge', String(werte.laenge))
  if (werte.titel) p.set('titel', werte.titel)
  window.open(`/karte?${p.toString()}`, '_blank', 'noopener')
}
